import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { useRouter } from 'next/router'
import ReactSVG from 'react-svg'
import { CookiesHelper } from 'Core/cookiesHelper/CookiesHelper'
import { Preloader } from 'SRC/ui/Preloader'
import { Notification } from 'react-notification'
import { getUserInfo } from 'SRC/modules/users/Profile/selectors'
import { setFormLoading } from 'SRC/modules/common/actions'
import { PromoRequestApi } from 'SRC/modules/ads/promoRequest/api'
import { getFormLoading } from 'SRC/modules/common/selectors'
import { getPromoRequest } from 'SRC/modules/ads/promoRequest/selectors'
import { CommonApi } from 'SRC/modules/common/api'

const ActivatePromoNLB = ({
  formLoading,
  user,
  promoRequest,
  setFormLoading,
}) => {
  const [notificationMessage, setNotificationMessage] = useState('')
  const [paymentInstance, setPaymentInstance] = useState(null)
  const [expiryDate, setExpiryDate] = useState('')

  const cookies = new CookiesHelper()
  const commonApi = new CommonApi()

  const router = useRouter()

  const { t, lang } = useTranslation('common')

  useEffect(() => {
    if (typeof window !== 'undefined' && window.PaymentJs) {
      const payment = new window.PaymentJs()

      try {
        payment.init(
          'JXh7KRgAxiNRCBt4rrhG',
          // 'tEdBjGRfZvVCl5h4QPKV', OG
          'number_div',
          'cvv_div',
          function (paymentObj) {
            setPaymentInstance(paymentObj)

            // Style the card number iframe
            paymentObj.setNumberStyle({
              'border': '1px solid #ddd',
              'border-radius': '0.25rem',
              'padding': '0.875rem 1rem',
              'font-size': '0.875rem',
              'color': '#333',
              'width': '100%',
              'outline': 'none',
              'box-sizing': 'border-box'
            })

            paymentObj.setNumberPlaceholder('1234 1234 1234 1234')

            // Style the CVV iframe
            paymentObj.setCvvStyle({
              'border': '1px solid #ddd',
              'border-radius': '0.25rem',
              'padding': '0.875rem 1rem',
              'font-size': '0.875rem',
              'color': '#333',
              'width': '100%',
              'outline': 'none',
              'box-sizing': 'border-box'
            })

            paymentObj.setCvvPlaceholder('_ _ _')
          }
        )
      } catch (error) {
        console.error('Error initializing PaymentJs:', error)
      }
    } else {
      console.error('PaymentJs library not loaded')
      setNotificationMessage(t('payment_system_error'))
    }
  }, [])

  const handleExpiryDateChange = (e) => {
    let value = e.target.value.replace(/\D/g, '') // Remove non-digits
    if (value.length > 4) value = value.slice(0, 4) // Limit to 4 digits
    if (value.length >= 3) {
      value = value.slice(0, 2) + '/' + value.slice(2) // Insert "/" after MM
    }
    setExpiryDate(value)
  }

  const onSubmit = async (e) => {
    e.preventDefault()

    setNotificationMessage('')
    setFormLoading(true)

    if (paymentInstance) {
      const formData = new FormData(e.target)

      console.log('expiryDate', formData.get('expiryDate'))

      const data = {
        card_holder: formData.get('cardholderName'),
        month: formData.get('expiryDate') ? formData.get('expiryDate')?.split('/')?.[0]?.trim() : '',
        year: formData.get('expiryDate') ? formData.get('expiryDate')?.split('/')?.[1]?.trim() : '',
      }
      console.log('data', formData.get('expiryDate'))

      paymentInstance.tokenize(data,
        async function (token, cardData) {
          console.log('Tokenization successful. Token:', token)
          console.log('Card Data:', cardData)
          const amount = `${promoRequest?.promoRequestListing?.price?.toFixed(2)}` || 0
          const listing = promoRequest?.listing
          const adCode = promoRequest?.adCode || ''
          const username = user?.username || ''

          try {
            const api = new PromoRequestApi()
            const response = await api.createBankartTransaction({
              paymentJSToken: token,
              amount,
              listing,
              adCode,
              username,
              locale: lang?.toUpperCase() || 'ME'
            })

            console.log('createBankartTransaction response', response)

            if (response?.error) {
              setNotificationMessage(response?.error)
              setFormLoading(false)
              return
            }

            if (response?.success && response?.redirectUrl) {
              window.location.href = response.redirectUrl
            } else {
              setNotificationMessage(response?.error)
              setFormLoading(false)
              return
            }
          } catch (error) {
            console.error('createBankartTransaction error', error)
            setNotificationMessage(error.message)
            setFormLoading(false)
          }
        },
        function (errors) {
          console.error('Tokenization errors:', errors)

          if (Array.isArray(errors) && errors.length) {
            const error = errors[0]
            error.message && setNotificationMessage(error.message)
            setFormLoading(false)
          }
        }
      )
    } else {
      setNotificationMessage('')
      setFormLoading(false)
    }
  }

  return (
    <div className='vehicle-parts-orders-online-payment'>
      <div className='vehicle-parts-orders-online-payment__header'>
        <button
          type='button'
          className='vehicle-parts-orders-online-payment__header-back'
          onClick={() => router.back()}
          aria-label='Go back'
        >
          <ReactSVG src='/icons/back.svg' beforeInjection={(svg) => {
            svg.setAttribute('style', 'width: 24px; height: 24px;')

            svg.querySelectorAll('path').forEach(path => {
              path.setAttribute('fill', '#fff')
            })
          }} />
        </button>
        <p className='vehicle-parts-orders-financing__header-title'>
          {t('online_payment')}
        </p>
      </div>

      <div className='vehicle-parts-orders-online-payment-wrapper'>
        <div className='vehicle-parts-orders-online-payment-inner' />

        <div className='vehicle-parts-orders-online-payment-content'>
          <form onSubmit={onSubmit}>
            <div className='bank-transfer__form-section'>
              <div className='online-payment-form-intro'>
                <ReactSVG src='/icons/plati-karticom.svg' beforeInjection={(svg) => {
                  svg.setAttribute('style', 'width: 75px; height: 75px;')
                }} />

                <p className='financing-form-intro__title' style={{ marginTop: '1rem' }}>
                  {t('online_payment')}
                </p>

                <p className='financing-form-intro__text'>
                  {t('enter_card_details')}
                </p>
              </div>

              <div className='bank-transfer__form-group'>
                <label className='bank-transfer__form-label'>
                  {t('name_surname')} <span className='bank-transfer__form-required'>*</span>
                </label>
                <input
                  type='text'
                  name='cardholderName'
                  className='bank-transfer__form-input'
                  placeholder='Marko Marković'
                />
              </div>

              <div className='bank-transfer__form-group'>
                <label className='bank-transfer__form-label'>
                  {t('card_number')} <span className='bank-transfer__form-required'>*</span>
                </label>

                <div id="number_div" style={{ maxHeight: '45px' }} />
              </div>

              <div className='bank-transfer__form-row'>
                <div className='bank-transfer__form-group bank-transfer__form-group--half'>
                  <label className='bank-transfer__form-label'>
                    {t('expiry_date')} <span className='bank-transfer__form-required'>*</span>
                  </label>
                  <input
                    type='text'
                    name='expiryDate'
                    className='bank-transfer__form-input'
                    placeholder='MM/YY'
                    value={expiryDate}
                    onChange={handleExpiryDateChange}
                    maxLength={5}
                  />
                </div>

                <div className='bank-transfer__form-group bank-transfer__form-group--half'>
                  <label className='bank-transfer__form-label'>
                    CVV <span className='bank-transfer__form-required'>*</span>
                  </label>
                  <div className='bank-transfer__form-input-wrapper'>
                    <div id="cvv_div" style={{ maxHeight: '45px' }} />
                    <span className='bank-transfer__form-help-icon'>?</span>
                  </div>
                </div>
              </div>

              <div className='bank-transfer__form-group'>
                <button
                  type='submit'
                  className='vehicle-parts-orders-online-payment__submit'
                  disabled={formLoading}
                >
                  {t('PLATI')}
                </button>
              </div>

              <div className='bank-transfer__form-group'>
                <div className='bank-transfer-link__cards'>
                  <img height={48} src='/icons/visa_pos_fc.png' />
                  <img height={48} src='/icons/mc_vrt_opt_pos_63_3x.png' />
                  <img height={48} src='/icons/ms_vrt_opt_pos_73_3x.png' />
                  <img height={48} src='/icons/mc_idcheck_vrt_pos.png' />
                  <img height={48} src='/icons/visa-secure_blu_72dpi.jpg' />
                  <img height={48} src='/icons/Logo_NLB_Banka_sponzorski_10mm_RGB.png' />
                </div>
              </div>

              <div className='vehicle-parts-orders__result-details'>
                {promoRequest?.promoRequestListing?.price ? (
                  <div className='vehicle-parts-orders__result-detail'>
                    <span className='vehicle-parts-orders__result-detail-label'>{t('Iznos')}</span>
                    <span className='vehicle-parts-orders__result-detail-value--highlight'>{promoRequest?.promoRequestListing?.price} €</span>
                  </div>
                ) : null}

                {promoRequest?.adCode ? (
                  <div className='vehicle-parts-orders__result-detail'>
                    <span className='vehicle-parts-orders__result-detail-label'>{t('payment_purpose')}</span>
                    <span className='vehicle-parts-orders__result-detail-value'>{promoRequest?.adCode}</span>
                  </div>
                ) : null}

                <div className='vehicle-parts-orders__result-detail'>
                  <span className='vehicle-parts-orders__result-detail-label'>{t('Primalac')}</span>
                  <span className='vehicle-parts-orders__result-detail-value'>WebLab d.o.o. Bar</span>
                </div>
              </div>

              <div className='bank-transfer__form-group'>
                <button
                  type='button'
                  className='vehicle-parts-orders-online-payment__cancel'
                  disabled={formLoading}
                  onClick={() => router.push('/')}
                >
                  {t('OTKAŽI')}
                </button>
              </div>
            </div>
            {formLoading ? <Preloader /> : null}

            <Notification
              isActive={!!notificationMessage}
              message={notificationMessage}
              action={t('Sakrij')}
              onClick={() => { setNotificationMessage('') }}
            />
          </form>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    user: getUserInfo(state),
    promoRequest: getPromoRequest(state),
    formLoading: getFormLoading(state)
  }
}

ActivatePromoNLB.propTypes = {
  user: PropTypes.object.isRequired,
  promoRequest: PropTypes.object.isRequired,
  formLoading: PropTypes.bool.isRequired,
  setFormLoading: PropTypes.func.isRequired
}

const enhance = compose(
  connect(mapStateToProps, { setFormLoading })
)

export default enhance(ActivatePromoNLB)
